var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproveWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_7946)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_7946",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_7946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5423 8.71744C47.0743 8.24506 46.5173 7.8701 45.9036 7.61421C45.2898 7.35831 44.6314 7.22656 43.9665 7.22656C43.3015 7.22656 42.6432 7.35831 42.0294 7.61421C41.4157 7.8701 40.8587 8.24506 40.3907 8.71744L18.6779 30.5667L9.60936 21.4426C9.14134 20.9703 8.58437 20.5954 7.97063 20.3395C7.35688 20.0836 6.69853 19.9519 6.03358 19.9519C5.36864 19.9519 4.71028 20.0836 4.09654 20.3395C3.4828 20.5954 2.92583 20.9703 2.4578 21.4426C1.50893 22.4 0.976562 23.6933 0.976562 25.0413C0.976563 26.3892 1.50893 27.6825 2.4578 28.6399L15.102 41.3645C15.5699 41.8371 16.1269 42.2122 16.7406 42.4682C17.3544 42.7242 18.0128 42.856 18.6778 42.856C19.3428 42.856 20.0013 42.7242 20.615 42.4682C21.2288 42.2122 21.7857 41.8371 22.2536 41.3645L47.5423 15.9147C48.4912 14.9574 49.0236 13.664 49.0236 12.3161C49.0236 10.9681 48.4912 9.67477 47.5423 8.71744Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_7946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveWhite);
export default __webpack_public_path__ + "static/media/approve_white.a3d5d68ac7daec6c36d0b5108228dfed.svg";
export { ForwardRef as ReactComponent };